class BuySlot extends PIXI.Container {
	static textStyle = new PIXI.TextStyle({
		fontFamily: 'courier',
		fontStyle: 'bold',
		fontSize: "10pt",
		fill: 0xffffff
	});

	btn: Button;
	txt: PIXI.Text;
	txtPanel: PIXI.Sprite;

	_cost: string;

	constructor() {
		super();
		this.btn = new Button(Assets.ui.button);
		this.addChild(this.btn);
		centerFrickingSprite(this.btn);

		this.txtPanel = new PIXI.Sprite(Assets.ui.cost);
		centerFrickingSprite(this.txtPanel);
		this.txtPanel.position.set(0, 36);

		this.txt = new PIXI.Text("-", BuySlot.textStyle);
		this.txtPanel.addChild(this.txt);
		this.btn.addChild(this.txtPanel);

		this.cost = "99999";
	}

	get cost() {
		return this._cost;
	}

	set cost(value: string) {
		this._cost = value;
		this.txt.text = value + "";
		(this.txt as any).updateText(false);
		centerFrickingSprite(this.txt);
	}

	update() {
		let money = Game.statBar.money;
		this.btn.setEnabled(money >= +this._cost);
	}

	tutored: boolean = false;
	checkTutor() {
		if (Tutorial.active) {
			if (this.tutored) {
				Tutorial.next();
			} else {
				return true;
				// Tutorial.end();
			}
			this.tutored = false;
		}
		return false;
	}
}
